import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  ButtonResponsiveWrapper,
  InvestmentsLiquidationReactivate,
  useResponsive,
} from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';

import { useInvestor } from '../../hooks';
import { InvestmentPaths } from '../../investments.types';
import { InvestmentReactivationModal } from '../../InvestmentSwitchModal';
interface Props {
  accountId?: string;
}
const InvestmentReactivate: React.FC<Props> = ({ accountId }) => {
  const [visible, setVisible] = useState(false);
  const [isChangeModel, setChangeModel] = useState(false);
  const {
    data: { type: investorType },
    isOnlyOneInvestmentPath,
  } = useInvestor(accountId);
  const isSelfDirectedMode = useMemo(() => investorType === InvestmentPaths.SELF_DIRECTED, [investorType]);
  const handleToggle = useCallback(
    (isChangeModelValue: boolean) => () => {
      setChangeModel(isChangeModelValue);
      setVisible(!visible);
    },
    [visible]
  );

  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  return (
    <Box
      direction="column"
      pad={isMobile ? 'spacing16' : 'spacing24'}
      data-testid="investment-reactivate"
      background="border1"
      round="moduleRound"
    >
      <InvestmentReactivationModal
        key={`${visible}`}
        isChangeModel={isChangeModel}
        isSelfDirectedMode={isSelfDirectedMode}
        accountId={accountId}
        visible={visible}
        onSetVisible={setVisible}
      />

      <Banner
        isWideMode
        title={t('Ready to Invest Again?')}
        description={t(
          "You've successfully liquidated your investment portfolio. Your investments account is now empty."
        )}
        icon={<InvestmentsLiquidationReactivate />}
        testId="investment-reactivate"
      >
        <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
          <AppButton
            fill={isMobile}
            testId="investment-reactivate_start-investing"
            onClick={handleToggle(false)}
            width="220px"
          >
            {`${t('Restart With ')} ${isSelfDirectedMode ? t('Self Directed') : t('Managed')}`}
          </AppButton>
          <AppButton
            fill={isMobile}
            buttonType="secondary"
            testId="investment-reactivate_start-investing_change-model"
            onClick={handleToggle(true)}
            width="220px"
          >
            {isOnlyOneInvestmentPath ? t('Restart Investing') : t('Invest With Another Model')}
          </AppButton>
        </ButtonResponsiveWrapper>
      </Banner>
    </Box>
  );
};
export default InvestmentReactivate;
